import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";

export const authUserState = (state: RootState) => state.auth;

export const authUser = createSelector([authUserState], (auth) => auth.user);

export const authError = createSelector([authUserState], (auth) => auth.error);
